import { FaUsers, FaShieldAlt } from "react-icons/fa";
import { GiShuttlecock, GiTrophy } from "react-icons/gi";
import { MdOutlineWbIncandescent } from "react-icons/md";
import { IoMdTime } from "react-icons/io";

const features = [
  {
    title: "Professional Indoor Court",
    description: "A premium full-size court built for consistent play and competitive practice.",
    icon: <GiShuttlecock className="h-7 w-7 text-emerald-300" />,
  },
  {
    title: "LED Lighting",
    description: "Modern lighting designed for visibility, speed, and match-quality performance.",
    icon: <MdOutlineWbIncandescent className="h-7 w-7 text-emerald-300" />,
  },
  {
    title: "Court Available Daily",
    description: "Open every day from early morning until late evening for regular play.",
    icon: <IoMdTime className="h-7 w-7 text-emerald-300" />,
  },
  {
    title: "Experienced Trainers",
    description: "Two professional coaches ready to support beginners, intermediates and advanced players.",
    icon: <FaUsers className="h-7 w-7 text-emerald-300" />,
  },
  {
    title: "Clean & Well-Maintained",
    description: "A safe, hygienic academy environment for families and athletes.",
    icon: <FaShieldAlt className="h-7 w-7 text-emerald-300" />,
  },
  {
    title: "Friendly Environment",
    description: "A welcoming training space focused on growth, confidence and community.",
    icon: <GiTrophy className="h-7 w-7 text-emerald-300" />,
  },
];

const WhyChooseUs = () => {
  return (
    <section id="why" className="mx-auto max-w-7xl px-6 py-20 sm:px-8 lg:px-12">
      <div className="mb-12 max-w-3xl">
        <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">About KG Shuttle Court</p>
        <h2 className="section-heading mt-4">Professional indoor badminton in Mangadu.</h2>
        <p className="section-copy">
          KG Shuttle Court offers a professional indoor badminton experience for players of all skill levels. Whether you are looking for regular play sessions or professional coaching, we provide a clean, safe, and friendly environment to improve your game.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {features.map((feature) => (
          <div key={feature.title} className="section-card flex flex-col gap-4 transition hover:-translate-y-1 hover:border-emerald-400/20">
            <div className="flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-900/80">{feature.icon}</div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold text-white">{feature.title}</h3>
              <p className="text-slate-400">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
